export function isSubRoute(route: string) {
  return route.split(`/`).length > 2;
}
